import React from 'react';
import styled from 'styled-components';
import { breakpoints, device } from '@src/common/breakpoints';
import { useAppSelector } from '@src/core/hooks';
import { cartStateSelector } from '@src/features/cart/store/cart';
import CartDetailsContent from './CartDetailsContent';

const CartDetails = () => {
  const { isModalOpened } = useAppSelector(cartStateSelector);

  return (
    <SideMenu role='region' aria-live='polite' visible={isModalOpened}>
      <CartDetailsContent />
    </SideMenu>
  );
};

interface SideMenuProps {
  visible: boolean;
}
const SideMenu = styled.div<SideMenuProps>`
  position: absolute;
  background-color: white;
  display: flex;
  flex-direction: column;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  transform: ${(props) => (props.visible ? 'translateX(0)' : 'translateX(100%)')};
  transition: all 0.3s ease-in-out;
  ${device.mobile} {
    width: ${breakpoints.mobile};
  }
`;

export default CartDetails;
